import React from 'react';
import { useEventLogContext } from '../../context/EventLogContext';
import { EventEntry, EventColumn } from '../../types';
import { timeStr } from '../../engine/stats';

const COL_HEADERS = [
  '시선/포즈',
  '스타일러스',
  '키보드',
  '음성',
];

function EventItem({ entry, highlighted }: { entry: EventEntry; highlighted: boolean }) {
  return (
    <div className={`ev-item ${entry.level} ${highlighted ? 'highlighted' : ''}`}>
      <span className="ev-time">{timeStr(entry.t)}</span>
      <span className="ev-msg">{entry.msg}</span>
      {entry.zScore !== null && (
        <span className="ev-z">Z:{entry.zScore.toFixed(1)}</span>
      )}
    </div>
  );
}

export function EventLogColumns() {
  const { columns, highlightWindow } = useEventLogContext();

  return (
    <div className="event-log-section">
      <h3>이벤트 로그</h3>
      <div className="event-log-grid">
        {([0, 1, 2, 3] as EventColumn[]).map(colIdx => (
          <div className="event-col" key={colIdx}>
            <div className="event-col-header">{COL_HEADERS[colIdx]}</div>
            <div className="event-col-body">
              {columns[colIdx].length === 0 ? (
                <div style={{ padding: 8, fontSize: 9, color: 'var(--dim)', textAlign: 'center' }}>
                  대기 중
                </div>
              ) : (
                columns[colIdx].slice(0, 40).map(entry => (
                  <EventItem
                    key={entry.id}
                    entry={entry}
                    highlighted={
                      !!highlightWindow &&
                      entry.t >= highlightWindow.start &&
                      entry.t <= highlightWindow.end
                    }
                  />
                ))
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
